const BulkActionType = Object.freeze({
  Activate: 1,
  Deactivate: 2,
  Delete: 3,
});

export default BulkActionType;
